

































import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GTemplateCard2',
  props: {
    image: { type: String as PropType<string>, required: true },
    wireImage: { type: String as PropType<string>, required: true },
    demoImage: { type: String as PropType<string>, required: true },
    templateType: { type: String as PropType<string>, required: true },
    description: { type: String as PropType<string>, required: true },
    recommends: { type: Array as PropType<string[]>, required: true },
    previewEvt: { type: Function as PropType<Function>, required: true },
    createEvt: { type: Function as PropType<Function>, required: true },
  },
});
